import { useSelector } from "react-redux";
import HorizontalTabs from "../../components/HorizontalTabs";
import { Organisation as OrganisationType } from "../../models/Organisation";
import { ApplicationState } from "../../store";
import { useGetOrganisationQuery } from "../../store/api/kinesense";
import MetadataEditor from "./components/metadataEditor/MetadataEditor";
import OrganisationDetails from "./components/OrganisationDetails";
import { UserGroups } from "./components/usergroups/UserGroups";
import Users from "./components/users/Users";
import "./Organisation.scss";
import { User } from "../../models/User";

interface OrganisationDetailsProps {
    orgData?: OrganisationType;
}

export default function Organisation(props: OrganisationDetailsProps) {
    const user = useSelector((state: ApplicationState) => state.user);
    const isForCurrentUsersOrganisation = props.orgData === undefined;

    const { data: organisation, isLoading } = isForCurrentUsersOrganisation
        ? useGetOrganisationQuery()
        : { data: props.orgData, isLoading: false };

    const tabsMap: {
        [key: string]: JSX.Element;
    } = {
        About: <OrganisationDetails organisation={organisation} isLoading={isLoading} />,
    };

    const perms = user?.permissions.permissions;
    if (perms && (User.can(perms, "read", "users") || User.can(perms, "peek", "users"))) {
        tabsMap["Users"] = (
            <Users organisation={organisation} isForCurrentUsersOrganisation={isForCurrentUsersOrganisation} />
        );
    }

    if (perms && (User.can(perms, "read", "groups") || User.can(perms, "peek", "groups"))) {
        tabsMap["Groups"] = <UserGroups organisation={organisation} />;
    }

    // if (perms && (User.can(perms, "read", "projects") || User.can(perms, "peek", "projects"))) {
    //     tabsMap["Projects"] = <Projects organisation={organisation} />;
    // }

    if (isForCurrentUsersOrganisation) {
        tabsMap["Metadata"] = <MetadataEditor />;
    }

    return (
        <main className="container organisation">
            <header className="gap-2 mb-2 d-flex align-items-end">
                <h4 className="mb-0">Organisation</h4>
                <span className="text-muted">&gt;</span>
                <h5 className="mb-0 h4">{organisation?.name}</h5>
            </header>

            <HorizontalTabs tabsMap={tabsMap} />
        </main>
    );
}
